import axios from 'axios'
import { getAttachmentsPage } from '@/services/attachments.service'
import { GATEWAY_HOST } from '@/composables/useMapbox'

export interface WmsSource {
  url: string
  [key: string]: any
}

export async function generateWmsBoundingBoxes(
  wmsList: WmsSource[]
): Promise<(WmsSource & { boundingBox?: [string, string, string, string] })[]> {
  let wmssWithBoundingBoxList: (WmsSource & { boundingBox?: [string, string, string, string] })[] =
    []
  const promises = wmsList.map((wmsSource) => getCapabilities(wmsSource))
  const result = await Promise.allSettled(promises)
  result.forEach((capability, index) => {
    if (capability.status === 'fulfilled') {
      const wmsCapabilitiesDoc = new DOMParser().parseFromString(
        capability.value as string,
        'text/xml'
      )
      // In future solution, latLonBoundingBox should probably be saved by layer instead of just picking the first one
      const latLonBoundingBox = wmsCapabilitiesDoc.querySelector('LatLonBoundingBox')
      if (!latLonBoundingBox) return
      const minx = latLonBoundingBox.getAttribute('minx') ?? ''
      const miny = latLonBoundingBox.getAttribute('miny') ?? ''
      const maxx = latLonBoundingBox.getAttribute('maxx') ?? ''
      const maxy = latLonBoundingBox.getAttribute('maxy') ?? ''
      wmssWithBoundingBoxList.push({
        ...wmsList[index],
        boundingBox: [minx, miny, maxx, maxy]
      })
    } else {
      wmssWithBoundingBoxList.push({
        ...wmsList[index]
      })
    }
  })
  wmssWithBoundingBoxList = wmssWithBoundingBoxList.filter((wms) => wms.boundingBox)
  return wmssWithBoundingBoxList
}

async function getCapabilities(wmsSource: WmsSource): Promise<string | undefined> {
  const keycloakToken = localStorage.getItem('currentKeycloakToken') ?? ''
  const capabilitiesResponse = wmsSource.url.includes(GATEWAY_HOST)
    ? await getCapabilitiesRequest(wmsSource.url, keycloakToken)
    : await getCapabilitiesRequest(wmsSource.url)
  return capabilitiesResponse?.data
}

function getCapabilitiesRequest(url: string, token?: string) {
  const capabilitiesEndpoint = '?request=GetCapabilities&version=1.1.1&service=WMS'
  return axios.get(
    url + capabilitiesEndpoint,
    token
      ? {
          headers: {
            Authorization: 'Bearer ' + token
          },
          timeout: 7000
        }
      : undefined
  )
}

export async function getWmsList(entityId: string): Promise<any[] | undefined> {
  const response = await getAttachmentsPage(entityId, ['WMS'], 0, 30)
  return response?.content
}
